// import { getInicisData } from "src/service/pay";

import { getProductFromSessionStorage } from "../storage/auth";

// 환경(운영/테스트) · 제품별 PayPal SDK 옵션
// react-paypal-button-v2의 options로 넘기면 client-id 등 쿼리로 변환되어 SDK를 로드한다.
export const getPaypalOptions = () => {
  const isReal = window.location.hostname === "cloudportal.fasoo.com";
  const isEco = window.sessionStorage.getItem("product") === "WRAPSODY_ECO";
  const clientId = isReal
    ? isEco
      ? "ATGN4I7CwCO44AN0bRSopvYd3l32mQsHdHbfYvWlBHYB7oNKk2RUrdHeaMmSiHneQ8U99IwY3IcvT-Xe"
      : "Adq4eobfggrPc-JG_W9VRXW1FR4xEr9zu812LzY1tpJ4V8ocL5s5R339Ifsi5gdXdYBZaBf4CLoqzhOB"
    : isEco // 테스트 계정일때
      ? "AeANYYv4hmgzO6d9WLqJiwJEmqm-M28fkxfHHsKPG5IC2Q5-AaWc03aACVyTuNNbl79xEB4IOVF3YlIW"
      : "AdjG8uJfAZ8zs8697nP-vBBF4UhP08uMq5ydDazRgwsp9vxBC1Jb_y8lyP8VharULLxGUwOFgoFPhHGP";
  return isEco
    ? { clientId, vault: true, intent: "subscription" }
    : { clientId, vault: true };
};

export const insertPaypalModule = async () => {
  const paypalScript = document.createElement("script");
  const prodName = getProductFromSessionStorage();
  const payPalScriptId = `${prodName}-paypalScript`;
  paypalScript.id = payPalScriptId;
  const options = getPaypalOptions();
  paypalScript.src =
    `https://www.paypal.com/sdk/js?client-id=${options.clientId}&vault=true` +
    ("intent" in options ? `&intent=${options.intent}` : "");
  paypalScript.async = true;
  if (!document.getElementById(payPalScriptId)) {
    document.head.appendChild(paypalScript);
  }

  // let inicisData;

  // if (
  //   window.portal.customUserId === this.commonStore.userInfo.userInfo.userId
  // ) {
  //   inicisData = await getInicisData(
  //     window.portal.customUserPrice
  //   );
  // }
};
